import { useTranslation } from 'react-i18next';
import { LucideIcon } from './icons/LucideIcon.tsx';
import { PROVIDER_ICON, providerLabel, toProvider } from '../lib/providers.ts';

/** Small icon for where a ride came from, labelled "From …" for screen
 * readers; ``decorative`` when the same words are written next to it. */
export function ProviderIcon({ provider, size = 16, decorative = false }: Readonly<{
  provider?: string | null;
  size?: number;
  decorative?: boolean;
}>) {
  const { t } = useTranslation();
  const value = toProvider(provider);
  const label = t('sources.fromProvider', { provider: providerLabel(value, t) });
  return (
    <span className="shrink-0 text-(--color-text-secondary)" title={decorative ? undefined : label}
      data-testid="provider-icon" data-provider={value}>
      <LucideIcon name={PROVIDER_ICON[value]} size={size} label={decorative ? undefined : label} />
    </span>
  );
}
